const length = ['Full','Half','Short'];
const age = ['New','Recent','Regular','Old'];
const cats = ['Shirts', 'Tshirts', 'Pants'];
const fCats = ['Shoes'];

export {length, age, cats, fCats};